import React from 'react';

export default ({ label, description, value, onChange }) =>
  <div className="field">
    <label>{label}</label>
    <label className="inline">
      <input
        type="checkbox"
        checked={value}
        className="on"
        onChange={e => onChange(e.target.checked)}
      />
      <span className="span">{description}</span>
    </label>
  </div>;



// WEBPACK FOOTER //
// ./src/views/shared/checkbox.js